import { RootState } from '../store';
import { MilestoneMap1 } from '../../types';
import { getIntervalsForMilestoneMap } from '../../utils/getIntervalsForMilestoneMap';

// Pure selector functions
export const selectMilestoneMap = (state: RootState, mapUuid: string) =>
  state.map3Data.milestoneMaps.find((map) => map.uuid === mapUuid);

export const selectObjective = (state: RootState, objectiveUuid: string) =>
  state.map3Data.objectives.find((obj) => obj.uuid === objectiveUuid);

export function calculateIntervalRange(
  forIntervalEnding: string,
  milestoneMap: MilestoneMap1,
  intervalOverride?: MilestoneMap1['interval'],
): [Date, Date] {
  // Get all intervals for the map, using intervalOverride if provided for zoom functionality
  const intervals = getIntervalsForMilestoneMap(milestoneMap, intervalOverride);
  // Find the interval that ends at forIntervalEnding (full ISO match for precision)
  const found = intervals.find((interval) => interval.end.toISOString() === forIntervalEnding);
  if (!found) {
    // fallback: return the last interval
    return [intervals[intervals.length - 1].start, intervals[intervals.length - 1].end];
  }
  return [found.start, found.end];
}
